<template>
  <div class="notifications-container">
    <div class="notifications ml-2">
      <b-alert v-for="(alert, $index) in this.notificationsArray" :key="$index"
      :variant="alert.variant" show>
        <span>
          {{ alert.content }}
        </span>
        <span v-if="alert.nextRoute">
          <router-link :to="alert.nextRoute">View</router-link>
        </span>
      </b-alert>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      notificationsArray: [],
    };
  },
  created() {
    this.$root.$on('notification-add', this.showNotification);
  },
  beforeDestroy() {
    this.$root.$off('notification-add', this.showNotification);
  },
  methods: {
    showNotification(config) {
      const data = { ...config };
      const newNtfc = {
        content: data.content,
        variant: data.variant ? data.variant : 'info',
      };

      // ttl params (promise or fixed)
      if (data.ttl && data.ttl === Infinity && data.promise) {
        newNtfc.ttl = data.ttl;
        newNtfc.promise = data.promise;
        newNtfc.promise.catch(() => {}).finally(() => {
          this.hideNotification(newNtfc);
        });
      } else {
        newNtfc.ttl = setTimeout(() => { this.hideNotification(newNtfc); }, (data.ttl ? data.ttl : 5000));
      }

      // routing params
      if (data.nextRoute) {
        newNtfc.nextRoute = data.nextRoute;
      }

      this.notificationsArray.push(newNtfc);
    },
    hideNotification(n) {
      this.notificationsArray = this.notificationsArray.filter(e => e !== n);
    },
  },
};
</script>

<style lang="less" scoped>
  .notifications-container{
    z-index: 5000;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: flex-start;
    @media screen and (max-width: 767px){
      justify-content: center;
    }

    .notifications{
      max-width: 50%;
      @media screen and (max-width: 767px){
        max-width: 100%;
      }

      p{
        margin: 0;
      }
    }
  }
</style>
